<template>
  <b-modal
    size="lg"
    hide-footer
    v-model="show"
    centered
    :modal-class="isLoading ? 'loading' : ''"
  >
    <template v-slot:modal-header="{ cancel }">
      <h5 class="modal-title">{{title}}</h5>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click.prevent="cancel"
      >
        <span class="material-icons">
          close
        </span>
      </button>
    </template>
    <FormGenerator
      :data="form.fields"
      :isLoading="isLoading"
      @submit="submit"
    >
      <template v-slot:Projects="slotProps">
        <label class="form__label">{{slotProps.data.label}}</label>
        <multiselect
          v-model="slotProps.data.value"
          tag-placeholder="Select projects"
          :options="slotProps.data.options"
          track-by="key"
          label="name"
          return="id"
          multiple
          :showLabels="false"
        />
      </template>
    </FormGenerator>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormGenerator from '@components/FormGenerator'

export default {
  components: {
    FormGenerator
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Create partner'
    },
    countries: {
      type: Array
    },
    data: {
      type: Object
    },
    value: {
      type: Boolean
    }
  },
  data () {
    return {
      form: {
        fields: {
          'id': {
            name: 'id'
          },
          'company_name': {
            type: 'input',
            name: 'company_name',
            label: 'Company name',
            placeholder: 'Company name',
            value: null,
            class: 'col-12'
          },
          'first_name': {
            type: 'input',
            name: 'first_name',
            label: 'First Name',
            placeholder: 'First Name',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'last_name': {
            type: 'input',
            name: 'last_name',
            label: 'Last Name',
            placeholder: 'Last Name',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'email': {
            type: 'input',
            typeInput: 'email',
            name: 'email',
            label: 'Email',
            placeholder: 'Email',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'phone': {
            type: 'input',
            name: 'phone',
            label: 'Phone',
            placeholder: 'Phone',
            value: null,
            class: 'col-12'
          },
          'country': {
            type: 'select',
            name: 'country_id',
            label: 'Country',
            selectLabel: 'name',
            valueField: 'id',
            options: [],
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'city': {
            type: 'input',
            name: 'city',
            label: 'City',
            placeholder: 'City',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'address': {
            type: 'input',
            name: 'address',
            label: 'Address',
            placeholder: 'Address',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'zip_code': {
            type: 'input',
            name: 'zip_code',
            label: 'Zip Code',
            placeholder: 'Zip Code',
            value: null,
            class: 'col-12'
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      getCountries: 'countries/getCountries'
    }),
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    'countries': {
      deep: true,
      handler () {
        this.setCountries()
      }
    },
    'data': {
      deep: true,
      handler () {
        this.setParamsForEditBankDetailsModal()
      }
    }
  },
  created () {
    this.setInitialForm()
  },
  methods: {
    setInitialForm () {
      this.setCountries()
      this.setParamsForEditBankDetailsModal()
    },
    async setCountries () {
      let countries = this.countries

      if (!this.countries) {
        await this.fetchCountries()
        countries = this.getCountries
      }

      this.form.fields.country.options = countries
    },
    async fetchCountries () {
      if (this.getCountries.length) return

      return this.$api.country.getCountries()
    },
    setParamsForEditBankDetailsModal () {
      if (!this.data) return

      let value = ''

      for (let key in this.form.fields) {
        if (this.data[key]) {
          value = this.data[key]
        } else {
          value = ''
        }

        this.form.fields[key]['value'] = value
      }
    },
    submit (data) {
      this.$emit('submit', data)
    }
  }
}
</script>
